<template>
  <div class="app-main">
    <div class="top-bar">
      <el-input
        placeholder="输入订单号查询"
        v-model="title"
        @change="searchData"
        style="width: 240px"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button
        type="success"
        plain
        style="width: 120px; margin-left: 20px"
        @click="onSend()"
        >确认发货</el-button
      >
    </div>
    <!-- 商品列表 -->
    <el-card shadow="hover">
      <el-table
        ref="table"
        :data="tableData"
        height="535"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          align="center"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="订单号"
          align="center"
          width="185"
        ></el-table-column>
        <el-table-column
          prop="updated_at"
          label="处理时间"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column prop="shtel" label="收货人" align="center">
          <template slot-scope="scope">
            <el-link :underline="false" v-if="scope.row.order_logistics">{{
              scope.row.order_logistics.tel != ""
                ? scope.row.order_logistics.tel
                : scope.row.order_logistics.email
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="delivery_method_title"
          label="配送物流"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="order_status_title"
          label="订单状态"
          align="center"
        ></el-table-column>
        <el-table-column label="订单编辑" align="center">
          <template slot-scope="scope">
            <div class="table-btns">
              <el-button
                type="info"
                plain
                size="mini"
                @click="getDetail(scope.row.id)"
                >查看详情</el-button
              >
              <el-button
                type="primary"
                plain
                size="mini"
                @click="onPrint(scope.row.id)"
                >查看运单</el-button
              >
              <el-button
                type="success"
                plain
                size="mini"
                @click="onSend(scope.row.id)"
                v-if="scope.row.order_status == 1"
                >确认发货</el-button
              >
              <el-button
                type="danger"
                plain
                size="mini"
                @click="done(scope.row.id)"
                v-if="scope.row.order_status == 2"
                >确认送达</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="delivery_method_title"
          label="物流备注"
          align="center"
        >
          <template slot-scope="scope">
            <m-txt :name="scope.row.order_logistics.remarks" width="220px"></m-txt>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next"
        style="padding: 15px"
        :total="total"
        :page-size="size"
      ></el-pagination>
    </el-card>

    <!-- 展开商品详情弹框 -->
    <el-dialog
      title="订单详情"
      :visible.sync="detail_modal"
      :close-on-click-modal="false"
      center
      width="1200px"
    >
      <el-card class="m-bottom-4">
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >订单号码：{{ detail.title }}</el-col
          >
          <el-col :span="12" class="row-height"
            >下单时间：{{ detail.created_at }}</el-col
          >
        </el-row>
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >下单账号：{{
              detail.phone != ""
                ? detail.phone
                : detail.email != ""
                ? detail.email
                : detail.order_logistics.tel != ""
                ? detail.order_logistics.tel
                : detail.order_logistics.email
            }}</el-col
          >
          <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 0">收货方式：{{detail.delivery_method_title}} <span style="color:#409eff;">暂无</span></el-col>
          <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 1">
            收货方式：{{detail.delivery_method_title}} 
            <span style="color:#409eff;">MOOBYYOHO（{{detail.order_logistics.carrier_number}}）</span>
            </el-col>
          <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 2 || detail.order_logistics.delivery_method == 3">
            收货方式：{{detail.delivery_method_title}} 
            <span style="color:#409eff;">{{detail.order_logistics.carrier_name}}（{{detail.order_logistics.carrier_number}}）</span>
          </el-col>
          <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 4">
            收货方式：{{detail.delivery_method_title}} 
            <span style="color:#409eff;">商家自行配送（{{detail.order_logistics.carrier_number}}）</span>
            </el-col>
          <el-col :span="12" class="row-height" v-if="detail.order_logistics.delivery_method == 5">收货方式：{{detail.delivery_method_title}}</el-col>

        </el-row>
        <el-row class="row-height" v-if="detail.delivery_method == 1"
          >取 件 码 ：{{ detail.order_logistics.pick_up_code }}</el-row
        >
        <el-row
          class="row-height"
          v-if="detail.delivery_method == 0"
          style="padding-right: 36px"
        >
          地址详情：{{
            detail.order_logistics.surname +
            "  " +
            detail.order_logistics.name +
            "  " +
            detail.order_logistics.tel +
            ", " +
            detail.order_logistics.address +
            ", " +
            (detail.order_logistics.city_arr ? detail.order_logistics.city_arr.ename : detail.order_logistics.city_name) +
            ", " +
            detail.order_logistics.province_arr.abbreviation +
            ", " +
            detail.order_logistics.country_arr.ename +
            ", " +
            detail.order_logistics.zipcode
          }}
        </el-row>
      </el-card>
      <el-card class="m-bottom-4" v-if="detail.title">
        <p
          style="
            line-height: 40px;
            color: #666;
            font-size: 16px;
            border-bottom: 1px solid #e0e0e0;
            text-align: center;
          "
        >
          {{ detail.shops_title }}
        </p>
        <el-table :data="detail.order_goods" max-height="300">
          <el-table-column label="商品图片" align="center" width="100">
            <template slot-scope="scope">
              <m-img :src="scope.row.goods_sku_pic_url" />
            </template>
          </el-table-column>
          <el-table-column
            label="商品名称"
            show-overflow-tooltip
            align="center"
            width="200"
          >
            <template slot-scope="scope">{{ scope.row.goods_name }}</template>
          </el-table-column>
          <el-table-column
            label="商品规格"
            align="center"
            width="140"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.sku_name }}</template>
          </el-table-column>
          <el-table-column label="条形码" align="center" width="160">
            <template slot-scope="scope">{{ scope.row.barcode }}</template>
          </el-table-column>
          <el-table-column label="购买数量" align="center" width="80">
            <template slot-scope="scope">{{ scope.row.goods_number }}</template>
          </el-table-column>
          <el-table-column label="购买价格" align="center">
            <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.goods_price }}</template>
          </el-table-column>
          <el-table-column label="PST" align="center">
            <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.pst_amount }}</template>
          </el-table-column>
          <el-table-column label="GST" align="center">
            <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.gst_amount }}</template>
          </el-table-column>
          <el-table-column label="HST" align="center">
            <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.hst_amount }}</template>
          </el-table-column>
          <el-table-column label="QST" align="center">
            <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.qst_amount }}</template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card v-if="detail.title">
        <el-row class="row-height">
          <span class="row-span">商品价格：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.goods_amount }} </span>
          <span class="row-span">钱包抵扣：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.goods_wallet_fee }} </span>
          <span class="row-span"
            >优惠金额：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.goods_discount_fee }}
          </span>
          <span class="row-span" v-if="detail.pst_amount != '0.00'"
            >PST：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.pst_amount }}
          </span>
          <span class="row-span" v-if="detail.gst_amount != '0.00'"
            >GST：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.gst_amount }}
          </span>
          <span class="row-span" v-if="detail.hst_amount != '0.00'"
            >HST：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.hst_amount }}
          </span>
          <span class="row-span" v-if="detail.qst_amount != '0.00'"
            >QST：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.qst_amount }}
          </span>
          <span class="row-span">运费：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.shipping_fee }}</span>
        </el-row>
        <p
          style="
            text-align: right;
            font-size: 16px;
            font-weight: bold;
            padding: 0 30px 10px 0;
          "
        >
          支付总价：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.order_total_amount }}
        </p>
      </el-card>
    </el-dialog>

    <el-dialog title="配送单" center :visible.sync="logModel" width="500px">
      <div
        style="width: 350px; text-align: center"
        v-if="logData.delivery_method == 2"
      >
        <img
          style="width: 100%; display: block; margin: auto"
          :src="logData.carrier_waybill"
          alt="waybill"
        />
        <div style="text-align: center; padding-top: 20px">
          <el-button type="success" @click="onNext(logData.id)"
            >打印配送单 & 完成打包</el-button
          >
        </div>
      </div>
      <el-card v-else class="m-bottom-4">
        <div class="order-log" v-if="logData.delivery_method == 5">
          <p style="width: 100%; text-align: center; font-weight: bold">
            MOOBY YOHO
          </p>
          <p class="line">
            *******************************************************************
          </p>
          <p>ORDER: {{ logData.order_no }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <p>FROM: {{ logData.from }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <div class="addr-box">
            <p class="addr">
              ADR: {{ logData.shops_address }}
              {{ logData.shops_city_province_zipcode }}
              {{ logData.shops_country }}
            </p>
          </div>
          <p class="line">
            *******************************************************************
          </p>
          <p>TO: {{ logData.tel }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <p>TO ADR: Self Pick-Up</p>
          <p class="line">
            *******************************************************************
          </p>
          <p>Pick-Up Code: {{ logData.pick_up_code }}</p>
          <p class="line">
            *******************************************************************
          </p>
        </div>
        <div class="order-log"  v-else>
         <p style="width: 100%; text-align: center; font-weight: bold">
            MOOBY YOHO
          </p>
          <p class="line">
            *******************************************************************
          </p>
          <p>ORDER: {{ logData.order_no }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <p>FROM: {{ logData.from }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <div class="addr-box">
            <p class="addr">
              ADR: {{ logData.shops_address }}
              {{ logData.shops_city_province_zipcode }}
              {{ logData.shops_country }}
            </p>
          </div>
          <p class="line">
            *******************************************************************
          </p>
          <p>TO: {{ logData.to }}</p>
          <p class="line">
            *******************************************************************
          </p>
            <p>TEL: {{ logData.tel }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <div class="addr-box">
            <p class="addr">
              TOADR: {{ logData.to_address }}
              {{ logData.to_city_province_zipcode }}
              {{ logData.to_country }}
            </p>
          </div>
          <p class="line">
            *******************************************************************
          </p>
        </div>
        <div style="text-align: center; padding-top: 20px">
          <el-button
            type="success"
            @click="onNext(logData.id)"
            :disabled="disabled"
          >
            打印配送单
          </el-button>
        </div>
      </el-card>
      <!-- <div style="text-align:center;padding-top:20px;">
                <el-button type="success"  @click="onNext()">打印配送单 & 完成打包</el-button>
            </div> -->
    </el-dialog>
  </div>
</template>



<script>
import { order_detail } from "@/api/order.js";
import {
  packed_list,
  print,
  order_send,
  order_done,
  repeat_packed,
} from "@/api/warehouse.js";
import MImg from "./../../../components/Image";
import MTxt from "@/components/txt.vue";
export default {
  components: { MImg, MTxt },
  data() {
    return {
      title: "",
      tableData: [],
      total: 0,
      page: 1,
      size: 20,
      detail_modal: false,
      detail: {order_logistics:''},
      checkData: [], //选中通知库房的数据

      // 配送单
      logModel: false,
      logData: {},
      disabled: false,
    };
  },
  methods: {
    searchData() {
      this.page = 1;
      this.getData();
    },
    getData() {
      let params = { page: this.page };
      if (this.title != "") {
        params.search = this.title;
      }
      packed_list(params).then((res) => {
        if (res) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.size = res.data.per_page;
        }
      });
    },
    // 点击页数 加载当前点击页的数据
    reloadData(page) {
      this.page = page;
      this.getData();
    },

    // 获取订单详情
    getDetail(id) {
      let params = {
        special: 1,
      };
      order_detail(id, params).then((res) => {
        if (res) {
          this.detail = res.data;
          this.detail_modal = true;
        }
      });
    },
    // 打印配送单 处理下一单
    onNext(id) {
      this.disabled = true;
      repeat_packed(id)
        .then((res) => {
          if (res) {
            this.logModel = false;
            this.$message({ message: res.msg, type: "success", offset: 200 });
          }
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    // 监听 table 选中事件
    handleSelectionChange(rows) {
      rows.forEach((ele) => {
        this.checkData.push(ele.id);
      });
    },

    // 打印运单
    onPrint(id) {
      print(id).then((res) => {
        if (res) {
          this.logData = res.data;
          this.logData.id = id;
          this.logModel = true;
        }
      });
    },

    // 确认发货
    onSend(id) {
      let ids = [];
      if (id) {
        ids.push(id);
      } else {
        if (this.checkData.length == 0) {
          this.$message.error("至少选择一个订单");
          return false;
        } else {
          ids = this.checkData;
        }
      }
      order_send(ids.join(",")).then((res) => {
        if (res) {
          this.$message({ message: res.msg, type: "success", offset: 200 });
          this.getData();
        }
      });
    },
    done(id) {
      order_done(id).then((res) => {
        if (res) {
          this.$message({ message: res.msg, type: "success", offset: 200 });
          this.getData();
        }
      });
    },
    exportCard() {},
  },
  created() {
    this.getData();
  },
  activated() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.row-height {
  height: 40px;
  line-height: 40px;
  .row-span + .row-span {
    margin-left: 15px;
  }
}
.table-btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .el-button {
    margin-bottom: 5px;
  }
  .el-button + .el-button {
    margin-left: 0;
  }
}
.order-log {
  width: 350px;
  margin: 0 auto;
  > p {
    height: 40px;
    line-height: 40px;
    overflow: hidden;
  }
  .line {
    height: 20px;
    line-height: 20px;
  }
  .addr-box {
    height: 40px;
    display: flex;
    align-items: center;
  }
  .addr {
    line-height: 20px;
  }
}
</style>
